// extracted by mini-css-extract-plugin
export default {"text_cell":"TextCell_text_cell__Ai0OH","text_cell_bold":"TextCell_text_cell_bold__3Qiep","wrapper":"TextCell_wrapper__LFJwx","tooltip_wrapper":"TextCell_tooltip_wrapper__-uCQD"};